<template>
  <aside-modal 
    v-slot="{ close }" 
    v-model="bcOverviewsModalStore.show"
  >
    <div>
      <div class="bg-bc-blue text-white px-6 py-5 rounded-tl-md">
        <div class="flex items-center mb-2">
          <div class="text-lg flex-1">
            {{ $t('Overviews') }}
          </div>
          <div>
            <aw-icon 
              icon="close" 
              class="w-6 h-6 current-fill text-white cursor-pointer -mr-1.5 -mt-2" 
              @click="closeModal(close)" 
            />
          </div>
        </div>
      </div>
    </div>
    <!-- CONTENT NOT STICKY, OVERFLOWED IF NEEDED -->
    <div class="Overviews__Content p-6 overflow-y-auto flex-1 relative flex flex-col">
      <div class="flex flex-wrap items-center py-3">
        <nav 
          class="-mb-px flex flex-1" 
          aria-label="Tabs"
        >
          <tab-panel-pill
            v-for="(item, index) in tabs"
            :key="index"
            @click.stop.prevent="handleTypeChange(item.action)"
            :active="item.action === type"
            :icon="item.icon"
            :text="$t(item.text)"
            class="pill__Tab-white pill__Tab-hiddenTextMobile"
          />
        </nav>
      </div>
      <component 
        v-if="bcOverviewsModalStore.show"
        :is="`overviews-${type}-data`" 
      />
    </div>
    <!-- STICKY FOOTER - SUBMIT BUTTONS ALMOST -->
    <div class="flex-shrink-0 p-5 border-t border-gray-400">
      <div class="flex justify-end">
        <button 
          type="button" 
          class="btn btn-white" 
          @click="closeModal(close)"
        >
          <aw-icon
            icon="close"
            class="w-5 h-5 "
          />
          {{ $t('Close') }}
        </button>
      </div>
    </div>
  </aside-modal>
</template>

<script>
import { mapStores } from 'pinia'
import useBcOverviewsModalStore from '@/frontapp/store/bcOverviewsModal'

export default {
  props: {
    isPriviliged: Boolean
  },
  data() {
    return {
      type: this.isPriviliged ? 'access' : 'shared',
    }
  },
  computed: {
    ...mapStores(useBcOverviewsModalStore),
    tabs() {
      if (this.isPriviliged) {
        return [
          {
            action: 'access',
            icon: 'team',
            text: 'Accesses'
          },
          {
            action: 'shared',
            icon: 'share',
            text: 'Shared with'
          },
          {
            action: 'stats',
            icon: 'stats',
            text: 'Statistics'
          },
        ]
      } else {
        return [{
          action: 'shared',
          icon: 'share',
          text: 'Shared with'
        }]
      }
    },
    defaultType() {
      if (this.isPriviliged) {
        return 'access'
      } else {
        return 'shared'
      }
    }
  },
  methods: {
    closeModal(close) {
      this.type = this.defaultType
      this.bcOverviewsModalStore.closeModal()
      close()
    },
    handleTypeChange(type) {
      this.type = type
    },
  },
  watch: {
    'bcOverviewsModalStore.show': {
      handler(val) {
        if (!val) {
          this.bcOverviewsModalStore.closeModal()
          this.type = this.defaultType
        }
      }
    },
  }
}
</script>

<style lang="scss">
.Overviews__Content {
  .OverviewsItem {
    height: 60px;
  }
}
</style>
